import { render, staticRenderFns } from "./PageCover.vue?vue&type=template&id=aeb25a78&"
import script from "./PageCover.vue?vue&type=script&lang=js&"
export * from "./PageCover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports